import { AxiosError } from 'axios';
import { useMutation } from 'react-query';
import { requestCsv } from '../../../api/csv';

const useMutateRequestCsv = (onSuccess: () => void, onError: (error: AxiosError) => void) => {
  return useMutation<{}, AxiosError>(() => requestCsv(), {
    onSuccess,
    onError,
  });
};
export default useMutateRequestCsv;
